// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.set-password {
  --sp-primary: #0877bc;
  --sp-primary-dark: #065a8f;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: linear-gradient(
    145deg,
    color-mix(in srgb, var(--sp-primary) 88%, #0b1220) 0%,
    var(--sp-primary-dark) 55%,
    color-mix(in srgb, var(--sp-primary-dark) 70%, #041018) 100%
  );
  font-family: "IBM Plex Sans", "Segoe UI", system-ui, sans-serif;
}

.set-password__card {
  width: min(100%, 26rem);
  padding: 1.75rem 1.5rem 1.6rem;
  border-radius: 1.15rem;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  text-align: center;
  border-top: 4px solid var(--sp-primary);
}

.set-password__logo {
  display: block;
  max-width: 10rem;
  max-height: 3.5rem;
  width: auto;
  height: auto;
  margin: 0 auto 1rem;
  object-fit: contain;
}

.set-password__brand {
  margin: 0 0 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--sp-primary-dark);
}

.set-password h1 {
  margin: 0 0 0.5rem;
  font-size: 1.55rem;
  line-height: 1.2;
  color: #0f172a;
}

.set-password__sub {
  margin: 0 0 0.85rem;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.45;
}

.set-password__email {
  margin: 0 0 1rem;
  padding: 0.55rem 0.75rem;
  border-radius: 0.65rem;
  background: color-mix(in srgb, var(--sp-primary) 10%, #fff);
  color: #0f172a;
  font-weight: 600;
  font-size: 0.92rem;
  word-break: break-all;
}

.set-password__form {
  display: grid;
  gap: 0.85rem;
  text-align: left;
}

.set-password__label {
  display: grid;
  gap: 0.35rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
}

.set-password__label input {
  width: 100%;
  box-sizing: border-box;
  height: 2.7rem;
  padding: 0 0.85rem;
  border-radius: 0.7rem;
  border: 1px solid #cbd5e1;
  font: inherit;
  font-size: 1rem;
  font-weight: 500;
}

.set-password__label input:focus {
  outline: none;
  border-color: var(--sp-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--sp-primary) 22%, transparent);
}

.set-password__error {
  margin: 0;
  color: #b91c1c;
  font-size: 0.88rem;
  font-weight: 600;
}

.set-password__btn {
  margin-top: 0.25rem;
  width: 100%;
  height: 2.85rem;
  border: 0;
  border-radius: 0.8rem;
  cursor: pointer;
  color: #fff;
  font: inherit;
  font-weight: 700;
  background: linear-gradient(135deg, var(--sp-primary), var(--sp-primary-dark));
  box-shadow: 0 8px 18px color-mix(in srgb, var(--sp-primary) 35%, transparent);
}

.set-password__btn:disabled {
  opacity: 0.7;
  cursor: wait;
}

.set-password__state {
  display: grid;
  gap: 0.75rem;
  justify-items: center;
}

.set-password__spinner {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: 3px solid #e2e8f0;
  border-top-color: var(--sp-primary);
  animation: set-password-spin 0.9s linear infinite;
}

@keyframes set-password-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SetPassword.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB;;;;;GAKC;EACD,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,2DAA2D;EAC3D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,4EAA4E;AAC9E;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,8EAA8E;EAC9E,6EAA6E;AAC/E;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".set-password {\n  --sp-primary: #0877bc;\n  --sp-primary-dark: #065a8f;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: linear-gradient(\n    145deg,\n    color-mix(in srgb, var(--sp-primary) 88%, #0b1220) 0%,\n    var(--sp-primary-dark) 55%,\n    color-mix(in srgb, var(--sp-primary-dark) 70%, #041018) 100%\n  );\n  font-family: \"IBM Plex Sans\", \"Segoe UI\", system-ui, sans-serif;\n}\n\n.set-password__card {\n  width: min(100%, 26rem);\n  padding: 1.75rem 1.5rem 1.6rem;\n  border-radius: 1.15rem;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);\n  text-align: center;\n  border-top: 4px solid var(--sp-primary);\n}\n\n.set-password__logo {\n  display: block;\n  max-width: 10rem;\n  max-height: 3.5rem;\n  width: auto;\n  height: auto;\n  margin: 0 auto 1rem;\n  object-fit: contain;\n}\n\n.set-password__brand {\n  margin: 0 0 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--sp-primary-dark);\n}\n\n.set-password h1 {\n  margin: 0 0 0.5rem;\n  font-size: 1.55rem;\n  line-height: 1.2;\n  color: #0f172a;\n}\n\n.set-password__sub {\n  margin: 0 0 0.85rem;\n  color: #475569;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.set-password__email {\n  margin: 0 0 1rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 0.65rem;\n  background: color-mix(in srgb, var(--sp-primary) 10%, #fff);\n  color: #0f172a;\n  font-weight: 600;\n  font-size: 0.92rem;\n  word-break: break-all;\n}\n\n.set-password__form {\n  display: grid;\n  gap: 0.85rem;\n  text-align: left;\n}\n\n.set-password__label {\n  display: grid;\n  gap: 0.35rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.set-password__label input {\n  width: 100%;\n  box-sizing: border-box;\n  height: 2.7rem;\n  padding: 0 0.85rem;\n  border-radius: 0.7rem;\n  border: 1px solid #cbd5e1;\n  font: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.set-password__label input:focus {\n  outline: none;\n  border-color: var(--sp-primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--sp-primary) 22%, transparent);\n}\n\n.set-password__error {\n  margin: 0;\n  color: #b91c1c;\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.set-password__btn {\n  margin-top: 0.25rem;\n  width: 100%;\n  height: 2.85rem;\n  border: 0;\n  border-radius: 0.8rem;\n  cursor: pointer;\n  color: #fff;\n  font: inherit;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--sp-primary), var(--sp-primary-dark));\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--sp-primary) 35%, transparent);\n}\n\n.set-password__btn:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.set-password__state {\n  display: grid;\n  gap: 0.75rem;\n  justify-items: center;\n}\n\n.set-password__spinner {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  border: 3px solid #e2e8f0;\n  border-top-color: var(--sp-primary);\n  animation: set-password-spin 0.9s linear infinite;\n}\n\n@keyframes set-password-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
